import script from "./itemV3DiscsRatio.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3DiscsRatio.vue?vue&type=script&setup=true&lang=ts"

import "./itemV3DiscsRatio.vue?vue&type=style&index=0&id=61f41dda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f41dda"]])

export default __exports__